import { render, staticRenderFns } from "./ModalConnectTvMode.vue?vue&type=template&id=121481a9&scoped=true"
import script from "./ModalConnectTvMode.vue?vue&type=script&lang=js"
export * from "./ModalConnectTvMode.vue?vue&type=script&lang=js"
import style0 from "./ModalConnectTvMode.vue?vue&type=style&index=0&id=121481a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121481a9",
  null
  
)

export default component.exports